import SideSheet from "src/components/SideSheet"

import { useTracker } from "src/hooks/use_tracker"

export const useInvoiceTracker = () => {
  const tracker = useTracker()
  const surface = SideSheet.useInSideSheet() ? "sheet" : "page"

  return (action, properties = {}) =>
    tracker.trackEvent(`invoice_detail:${action}`, { surface, ...properties })
}
